import { useEffect, useState } from "react";
import { Feld, inputCls } from "@/components/einsatz/felder";

export const LEERE_STAMMDATEN = { vorname: "", nachname: "", strasse: "", hausnummer: "", plz: "", ort: "", adresszusatz: "", hinweise: "" };

export default function KundeStammdatenForm({ wert, onChange, fehler = {} }) {
  const w = { ...LEERE_STAMMDATEN, ...(wert || {}) };
  const set = (k) => (e) => onChange({ ...w, [k]: e.target.value });
  return (
    <div className="space-y-4" data-testid="kunde-stammdaten-form">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Feld label="Vorname" fehler={fehler.vorname}><input value={w.vorname} onChange={set("vorname")} autoComplete="off" className={inputCls(fehler.vorname)} data-testid="kunde-vorname" /></Feld>
        <Feld label="Nachname" fehler={fehler.nachname}><input value={w.nachname} onChange={set("nachname")} autoComplete="off" className={inputCls(fehler.nachname)} data-testid="kunde-nachname" /></Feld>
      </div>
      <p className="text-xs font-bold uppercase tracking-wider text-slate-500 pt-2">Einsatzadresse</p>
      <div className="grid grid-cols-3 gap-3">
        <div className="col-span-2"><Feld label="Straße" fehler={fehler.strasse}><input value={w.strasse} onChange={set("strasse")} autoComplete="off" className={inputCls(fehler.strasse)} data-testid="kunde-strasse" /></Feld></div>
        <Feld label="Nr." fehler={fehler.hausnummer}><input value={w.hausnummer} onChange={set("hausnummer")} autoComplete="off" className={inputCls(fehler.hausnummer)} data-testid="kunde-hausnummer" /></Feld>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <Feld label="PLZ" fehler={fehler.plz}><input value={w.plz} onChange={set("plz")} inputMode="numeric" autoComplete="off" className={inputCls(fehler.plz)} data-testid="kunde-plz" /></Feld>
        <div className="col-span-2"><Feld label="Ort" fehler={fehler.ort}><input value={w.ort} onChange={set("ort")} autoComplete="off" className={inputCls(fehler.ort)} data-testid="kunde-ort" /></Feld></div>
      </div>
      <Feld label="Adresszusatz" optional><input value={w.adresszusatz} onChange={set("adresszusatz")} placeholder="z. B. Hinterhaus, 2. OG" className={inputCls()} data-testid="kunde-adresszusatz" /></Feld>
      <Feld label="Organisatorische Hinweise" optional hint="z. B. Klingel, Gebäudezugang, Schlüssel"><textarea value={w.hinweise} onChange={set("hinweise")} rows={3} className="w-full min-w-0 rounded-xl border border-slate-200 px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-cyan-600" data-testid="kunde-hinweise" /></Feld>
    </div>
  );
}

export function useUnsavedWarning(dirty) {
  useEffect(() => {
    if (!dirty) return;
    const h = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, [dirty]);
}

export function useDirty(value) {
  const [start, setStart] = useState(() => JSON.stringify(value));
  const dirty = JSON.stringify(value) !== start;
  return [dirty, () => setStart(JSON.stringify(value))];
}
